export const ArrowStraight = ({ width = '16', height = '10' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1667 5.16667C14.8333 4.5 14.3333 4 13.75 3.75C13 3.33333 12.1667 3.33333 10.6667 3.33333H3.33333L5.25 1.41667C5.58333 1.08333 5.58333 0.583333 5.25 0.25C4.91667 -0.0833333 4.41667 -0.0833333 4.08333 0.25L0.75 3.58333C0.666667 3.66667 0.583333 3.75 0.583333 3.83333C0.5 3.91667 0.5 4.08333 0.5 4.16667C0.5 4.25 0.5 4.41667 0.583333 4.5C0.583333 4.58333 0.666667 4.66667 0.75 4.75L4.08333 8.08333C4.41667 8.41667 4.91667 8.41667 5.25 8.08333C5.58333 7.75 5.58333 7.25 5.25 6.91667L3.33333 5H10.6667C11.9167 5 12.5833 5 12.9167 5.16667C13.25 5.33333 13.5 5.58333 13.6667 5.91667C13.8333 6.25 13.8333 6.91667 13.8333 8.16667V9.16667C13.8333 9.66667 14.1667 10 14.6667 10C15.1667 10 15.5 9.66667 15.5 9.16667V8.16667C15.5 6.66667 15.5 5.83333 15.1667 5.16667Z"
        fill="currentColor"
        fillOpacity="0.4"
      />
    </svg>
  );
};
